import { animated, useTransition } from "@react-spring/three";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Interactables from "../Interactables/Interactables";
import ProjectsArea from "../ProjectsArea/ProjectsArea";

const SCENE_ROUTES = {
  MAIN: "main",
  PROJECTS: "projects",
} as const;

type SceneRoute = (typeof SCENE_ROUTES)[keyof typeof SCENE_ROUTES];

export default function SceneRouteTransition() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname !== "/" && location.pathname !== "/projects") {
      navigate("/", { replace: true });
    }
  }, [location.pathname, navigate]);

  const activeRoute: SceneRoute =
    location.pathname === "/projects"
      ? SCENE_ROUTES.PROJECTS
      : SCENE_ROUTES.MAIN;

  const transitions = useTransition<SceneRoute, { x: number; z: number }>(
    activeRoute,
    {
      from: (route) => ({
        x: route === SCENE_ROUTES.PROJECTS ? 0 : -10,
        z: route === SCENE_ROUTES.PROJECTS ? -10 : 0,
      }),
      enter: { x: 0, z: 0 },
      leave: (route) => ({
        x: route === SCENE_ROUTES.MAIN ? -10 : 0,
        z: route === SCENE_ROUTES.PROJECTS ? -10 : 0,
      }),
      config: { mass: 1, tension: 210, friction: 28 },
      exitBeforeEnter: true,
    },
  );

  return transitions((styles, route) => (
    <animated.group position-x={styles.x} position-z={styles.z}>
      {route === SCENE_ROUTES.PROJECTS ? <ProjectsArea /> : <Interactables />}
    </animated.group>
  ));
}
